import { testimonials } from "@/mocks/comics";

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14">
          <span className="inline-block text-xs font-medium text-foreground-500 bg-background-50 border border-background-200 rounded-full px-3 py-1 mb-4">读者口碑</span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
            百万读者的<br />真心推荐
          </h2>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <div key={t.id} className="break-inside-avoid mb-5 md:mb-6 bg-background-50 rounded-2xl p-5 md:p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.username}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                &ldquo;{t.comment}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}